module.exports = __webpack_public_path__ + "staticmobile/img/video_bg.29118a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video_bg.jpg
// module id = yU+v
// module chunks = 0